export default __webpack_public_path__ + "static/media/profile.f9106556.jpg";